function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[data-accordion-details-id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusMenuHandlers = {};

function trapFocusMenu(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[1];
  var last = elements[elements.length - 1];
  var searchInput = elements[elements.length - 2];

  removeTrapFocusMenu();

  trapFocusMenuHandlers.focusin = (event) => {
    if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusMenuHandlers.keydown);
  };

  trapFocusMenuHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusMenuHandlers.keydown);
  };

  trapFocusMenuHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
      searchInput.classList.remove('focus-inset');
    }

    // On the first focusable element and tab backward, focus the last element.
    if (
        (event.target === container || event.target === first) &&
        event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }

    if (
        (event.target === container || event.target === last) &&
        event.shiftKey
    ) {
      searchInput.classList.add('focus-inset');
    }
  };

  document.addEventListener('focusout', trapFocusMenuHandlers.focusout);
  document.addEventListener('focusin', trapFocusMenuHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocusMenu(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusMenuHandlers.focusin);
  document.removeEventListener('focusout', trapFocusMenuHandlers.focusout);
  document.removeEventListener('keydown', trapFocusMenuHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => {
      if (!button.classList.contains('search__button')) {
        button.addEventListener('click', this.onCloseButtonClick.bind(this));
      }
    });
  }

  onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      const openDetailsElement = event.target.closest('details[open]');
      if (!openDetailsElement) return;

      openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    elementToFocus.setAttribute('aria-expanded', false);
    elementToFocus.focus();
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');
    const menuMobile = this.header.querySelector('.menu-nav__close-btn');

    setTimeout(() => {
      menuMobile.focus();
    }, 100);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocusMenu(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dotsButtons = this.querySelectorAll('.slider-counter__link--dots');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.addEventListener('slideChanged', this.updateDots.bind(this));

    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
    this.sliderControlWrapper = this.querySelector('.slider-buttons');

    if (this.sliderControlWrapper) {
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1],
        currentDotButton: this.dotsButtons[this.currentPage - 1],
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);

    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  updateDots(obj) {
    let currentDotButton;

    if (obj instanceof HTMLElement) {
      currentDotButton = obj;
    } else {
      currentDotButton = obj.detail.currentDotButton
    }

    Array.from(this.dotsButtons).map((dotButton) => {
      dotButton.classList.remove('active');
    });
    currentDotButton.classList.add('active');
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();


    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('click', this.onVariantClick);
    this.addEventListener('keydown', (event) => {

      if (event.key === 'Enter') {
        const targetElement = event.target
        if (targetElement && typeof targetElement.click === 'function') {
          targetElement.click();
        }
      }
    });
    document.addEventListener('click', this.handleClickOutsideBox);
    document.addEventListener('keydown', (event) => {

      if (event.key === 'Enter') {
        this.handleClickOutsideBox(event);
      }
    });
    document.addEventListener('scroll', this.handleScroll);
    this.productId = this.getAttribute('data-product-id');
  }

  handleClickOutsideBox(e) {
    const isInput = e.target.hasAttribute('data-color-input');
    const variantSelects = e.target.closest('variant-selects');

    setTimeout(() => {
      if (variantSelects || isInput) {
        return;
      }

      const colorLists = document.querySelectorAll('[data-colors]');

      [].forEach.call(colorLists, function(el) {
        el.classList.remove('expanded');
      });
    }, 250);
  }

  handleScroll(e) {
    const colorLists = document.querySelectorAll('[data-colors]');

    [].forEach.call(colorLists, function(el) {
      el.classList.remove('expanded');
    });
  }

  onVariantClick(e) {

    const colors = this.querySelectorAll('[data-colors-item]');
    const color = e.target.closest('[data-colors-item]');

    if (!color) {
      return;
    }

    const colorList = this.querySelector('[data-colors]');
    const relatedAddBtnId = this.dataset.relatedAddBtn;
    const isPreorder = color.dataset.preorder === 'true';
    const isProductBundle = document.querySelector('.bundle-product__container.bundle-with-variants');

    if (color.classList.contains('current')) {
      colorList.classList.add('expanded');
    } else {
      [].forEach.call(colors, function(el) {
        el.classList.remove('current');
      });
      color.classList.add('current');
      colorList.classList.remove('expanded');
      if (isProductBundle) {
        const selectedColors = document.querySelectorAll('variant-selects .colors__item.current');
        const bundleProductVariants = document.querySelectorAll('.bundle-variation-details');

        const selectedColorNames = Array.from(selectedColors)
            .map(item => item.getAttribute('data-color'))
            .filter(color => color)
            .join(' / ');

        bundleProductVariants.forEach((bundleProductVariant, index) => {
          const bundleProductVariantTitle = bundleProductVariant.getAttribute('data-product-bundle-variant-title');
          const bundleProductVariantId = bundleProductVariant.getAttribute('data-product-bundle-variant-id');

          if (bundleProductVariantTitle === selectedColorNames) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('variant', bundleProductVariantId);
            window.history.replaceState(null, '', currentUrl.toString());

            const mainAddToCartBtn = document.getElementById('main-add-to-cart-btn');
            const stickyAddToCartBtn = document.getElementById('sticky-add-to-cart-btn');

            if (mainAddToCartBtn) {
              mainAddToCartBtn.dataset.variantId = bundleProductVariantId;
            }
            if (stickyAddToCartBtn) {
              stickyAddToCartBtn.dataset.variantId = bundleProductVariantId;
            }

            fetch(window.location.href)
                .then(response => {
                  if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
                  return response.text();
                })
                .then(responseText => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');

                  this.renderElement('MediaGallery', html);
                  this.renderElement('MediaGalleryThumbnails', html);
                  this.renderElement('BundleProducts', html);

                })
                .catch(error => console.error('Fetch error:', error));
          }
        });
      }
    }

    if (relatedAddBtnId) {
      const addBtn = document.getElementById(relatedAddBtnId);
      const textBtn = addBtn.querySelector('span');
      addBtn.dataset.variantId = color.dataset.variantId;
      addBtn.dataset.preorder = color.dataset.preorder;
      addBtn.dataset.preorderArrivalDate = color.dataset.preorderArrivalDate;

      if (isPreorder) {
        textBtn.textContent = 'Pre-Order Now';
      } else {
        textBtn.textContent = 'Add to Bag';
      }
    }
  }
  initWishlist() {
    setTimeout(() => {
      window.SmartWishlistScripts();
    }, 2000);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateAddToCartButtons();
      this.updateShareUrl();
      this.initWishlist();
    }
  }

  updateAddToCartButtons() {
    const mainAddToCartBtn = document.getElementById('main-add-to-cart-btn');
    const stickyAddToCartBtn = document.getElementById('sticky-add-to-cart-btn');
    if (mainAddToCartBtn) {
      mainAddToCartBtn.dataset.variantId = this.currentVariant.id;
    }
    if (stickyAddToCartBtn) {
      stickyAddToCartBtn.dataset.variantId = this.currentVariant.id;
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        this.renderElementAll('variant-title-description', html, '[data-variant-title-description]');
        this.renderElement('MediaGallery', html);
        this.renderElement('MediaGalleryThumbnails', html);
        this.renderElement('variant-colors', html);
        this.renderElement('variant-colors-' + this.productId, html);
        this.renderElement('product-form-submit', html);

      });
  }

  renderElementAll(prefix, html, destinationSelector) {
    const destinations = document.querySelectorAll(destinationSelector);
    const source = html.getElementById(`${prefix}-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

    if (source && destinations) {
      const destinationsArr = Array.from(destinations);
      destinationsArr.map((destination) => {
        destination.innerHTML = source.innerHTML;
      });
    }
  }

  renderElement(prefix, html) {
    const destination = document.getElementById(`${prefix}-${this.dataset.section}`);
    const source = html.getElementById(`${prefix}-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class QuantitySelect extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onChange);
  }

  onChange(e) {
    const select = e.target;
    const addToCartBtn = document.getElementById(select.dataset.relatedAddBtnId);
    console.log(select.dataset.relatedAddBtnId, 123);
    addToCartBtn.dataset.qty = select.value;
  }
}

customElements.define('quantity-select', QuantitySelect);

const chooseVariants = document.querySelectorAll('.quick-add__btn.choose-variant');

chooseVariants.forEach(function(variant) {
    const variantURL = variant.getAttribute('dataProductURL');
    variant.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            if (variantURL) {
                window.location.href = variantURL;
            }
        }
    });
    variant.addEventListener('click', function(event) {
        if (variantURL) {
            window.location.href = variantURL;
        }
    });
});

// A function that supports the GIF button in the navigation menu
function navMenuGifButtonClick(button) {
  button.addEventListener('click', function(event) {
    event.preventDefault();
    var imageID = button.getAttribute('data-header-image-id');
    var menuId = button.closest('.mega-menu__content').getAttribute('id');
    var ImageID = document.getElementById(menuId).querySelector('#ImageID-' + imageID);

    var playUrl = button.getAttribute('data-play-url');
    var pauseUrl = button.getAttribute('data-pause-url');

    if (button.classList.contains('playing')) {
      ImageID.src = pauseUrl;
      button.classList.remove('playing');
      button.setAttribute('aria-label', 'Play GIF');
    } else {
      ImageID.src = playUrl;
      button.classList.add('playing');
      button.setAttribute('aria-label', 'Pause GIF');
    }
  });
}

// Support for the GIF button in the footer
function footerGifButtonClick(button) {
  button.addEventListener('click', function() {
    var gifId = button.getAttribute('data-gif-id');
    var gifImage = document.getElementById('gifImage-' + gifId);

    var playUrl = button.getAttribute('data-play-url');
    var pauseUrl = button.getAttribute('data-pause-url');

    if (button.classList.contains('playing')) {
      gifImage.src = pauseUrl;
      button.classList.remove('playing');
      button.setAttribute('aria-label', 'Play GIF');
    } else {
      gifImage.src = playUrl;
      button.classList.add('playing');
      button.setAttribute('aria-label', 'Pause GIF');
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  // Support for GIF buttons in navigation menu
  document.querySelectorAll(".header-nav-drop__images .header-nav-drop__gif-btn").forEach(function(button) {
    navMenuGifButtonClick(button);
  });

  // Support for GIF buttons in the footer
  document.querySelectorAll('.footer-services .gif-btn').forEach(function(button) {
    footerGifButtonClick(button);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  document.body.style.minHeight = "100%";
});

// ADA for search input mobile and desktop

function observeSnizeAcElements() {
  const bodyObserver = new MutationObserver((mutations, obs) => {
    const targetNode = document.querySelector(".snize-ac-results");

    if (targetNode) {
      obs.disconnect();
      observeTarget(targetNode);
    }
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

(function createLiveRegion() {
  let region = document.getElementById("search-no-results-message");
  if (!region) {
    region = document.createElement("div");
    region.id = "search-no-results-message";
    region.setAttribute("role", "alert");
    region.setAttribute("aria-live", "assertive");
    region.classList.add("visually-hidden");
    document.body.appendChild(region);
  }
})();

function hasNoSearchResults() {
  const resultsContainer = document.querySelector(".snize-ac-results");
  return resultsContainer?.querySelector(".snize-nothing-found") !== null;
}

function observeTarget(targetNode) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;

        if (node.classList.contains("snize-ac-odd") || node.classList.contains("snize-ac-even")) {
          node.setAttribute("tabindex", "-1");
          const titleElement = node.querySelector(".snize-title");
          if (titleElement) {
            node.setAttribute("aria-label", titleElement.textContent.trim());
          }
        }

        if (node.classList.contains("snize-nothing-found")) {
          const span = node.querySelector("span");
          const message = span?.textContent.trim();
          if (message) {
            const searchInput = document.querySelector("#Search-Chantecaille-Com-desktop, #Search-Chantecaille-Com-tablet");
            if (searchInput) {
              searchInput.setAttribute("aria-label", message);
            }

            const liveRegion = document.getElementById("search-no-results-message");
            if (liveRegion) {
              liveRegion.textContent = message;
            }
          }
        }
      });
    });
  });

  observer.observe(targetNode, {
    childList: true,
    subtree: true
  });
}

let lastActiveSearchInput = null;

function closeSearchResults() {
  const resultsContainer = document.querySelector(".snize-ac-results");
  if (resultsContainer) {
    resultsContainer.style.display = "none";
  }
}

function enableKeyboardNavigation() {
  const searchInputs = document.querySelectorAll("#Search-Chantecaille-Com-desktop, #Search-Chantecaille-Com-tablet");

  searchInputs.forEach((inputEl) => {
    inputEl.addEventListener("blur", () => {
      if (hasNoSearchResults()) {
        inputEl.value = "";
        closeSearchResults();
      }
    });

    inputEl.addEventListener("focusin", () => {
      lastActiveSearchInput = inputEl;
      closeSearchResults();
    });
  });

  document.addEventListener("keydown", (event) => {
    let items = Array.from(document.querySelectorAll(".snize-ac-odd, .snize-ac-even"))
        .filter(item => item.offsetParent !== null);

    const focusedElement = document.activeElement;
    const currentIndex = items.indexOf(focusedElement);

    let searchInput;
    let searchIcon;

    if (window.innerWidth >= 1250) {
      searchInput = document.querySelector("#Search-Chantecaille-Com-desktop");
      searchIcon = document.querySelector(".search-icon--desktop");
    } else {
      searchInput = document.querySelector("#Search-Chantecaille-Com-tablet");
      searchIcon = document.querySelector(".search-icon--tablet");
    }

    if ((event.key === "Tab" || event.key === "ArrowDown") && hasNoSearchResults()) {
      if (document.activeElement === searchInput) {
        event.preventDefault();
        searchInput.value = "";
        closeSearchResults();
        searchIcon?.focus();
        return;
      }
    }

    if (event.key === "ArrowDown" || (event.key === "Tab" && !event.shiftKey)) {
      if (items.length) {
        event.preventDefault();
        if (currentIndex === items.length - 1) {
          searchIcon?.focus();
          closeSearchResults();
        } else {
          const nextIndex = (currentIndex + 1) % items.length;
          items[nextIndex].focus();
          updateAriaSelected(items, nextIndex);
        }
      }
    } else if (event.key === "ArrowUp" || (event.key === "Tab" && event.shiftKey)) {
      if (items.length) {
        event.preventDefault();
        if (currentIndex === 0) {
          searchInput?.focus();
          closeSearchResults();
        } else {
          const prevIndex = (currentIndex - 1 + items.length) % items.length;
          items[prevIndex].focus();
          updateAriaSelected(items, prevIndex);
        }
      }
    } else if (event.key === "ArrowRight" && focusedElement.classList.contains("snize-suggestion")) {
      event.preventDefault();
      focusedElement.click();
    } else if (event.key === "Enter" && focusedElement.classList.contains("snize-product")) {
      event.preventDefault();
      const productLink = focusedElement.querySelector("a");
      if (productLink) {
        productLink.click();
        if (searchInput) {
          searchInput.value = "";
          searchInput.focus();
          closeSearchResults();
        }
      }
    } else if (event.key === "Escape") {
      event.preventDefault();
      if (searchInput) {
        searchInput.value = "";
        searchInput.focus();
        closeSearchResults();
      }
    }
  });
}

function updateAriaSelected(items, index) {
  items.forEach((item, i) => {
    if (i === index) {
      item.setAttribute("aria-selected", "true");
      item.classList.add("focus-inset");
    } else {
      item.setAttribute("aria-selected", "false");
      item.classList.remove("focus-inset");
    }
  });
}

observeSnizeAcElements();
enableKeyboardNavigation();

function setTabIndexOnPandectesBanner() {
  const banner = document.getElementById("pandectes-banner");
  if (banner) {
    banner.setAttribute("tabindex", "-1");
  }
}

function observePandectesBanner() {
  const observer = new MutationObserver((mutations, obs) => {
    const banner = document.getElementById("pandectes-banner");
    if (banner) {
      banner.setAttribute("tabindex", "-1");
      obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

document.addEventListener("DOMContentLoaded", () => {
  setTabIndexOnPandectesBanner();
  observePandectesBanner();
});
